import { Navigate } from "react-router-dom";
import { STORAGE_KEYS } from "../../utils/constants";

/**
 * PrivateRoute Module
 * @module PrivateRoute
 * @description A higher-order component that protects routes from being accessed
 * by unauthenticated users. It checks for the presence of a valid token and
 * conversation ID in local storage. If the user is not authenticated, they are
 * redirected to the login page.
 * @param {Object} children - The child components to render if authenticated.
 * @returns {JSX.Element} The child components if authenticated, otherwise a
 * redirect to the login page.
 * @example
 * <PrivateRoute><YourComponent /></PrivateRoute>
 */
const PrivateRoute = ({ children }) => {
  const userDetails = JSON.parse(localStorage.getItem(STORAGE_KEYS.SESSION)) || {};
  const isAuthenticated = userDetails && userDetails.token && userDetails.conversationId;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;